import React, { useEffect, useRef, useState } from "react";
import Styles from "../homework/assets/Form.module.css";

import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import { dateFormat } from "../../dateFormat";
// import ExportFile from "./Helper";
import ForStudent from "./ForStudent";
import PaymentUpdates from "./PaymentUpdates";
import CommonEditor from "../masters/CommonEditor";

const Form = () => {
  const location = useLocation();
  const [editData, setEditData] = useState(location.state);
  const formRef = useRef(null);
  // const adminId = localStorage.getItem("_id");
  const [isLoading, setIsLoading] = useState(false);
  const [estimatedPriceData, setEstimatedPriceData] = useState();
  const [estimatedPrice, setEstimatedPrice] = useState(
    editData?.estimatedPrice || 0
  );
  const [discountPrice, setDiscountPrice] = useState(
    editData?.discountPrice || 0
  );
  const [promoPrice, setPromoPrice] = useState(editData?.promoPrice || 0);
  const [totalPrice, setTotalPrice] = useState(0);
  // const [paymentStatus, setPaymentStatus] = useState([]);
  // const [editingEnabled, setEditingEnabled] = useState(false);
  const [question, setQuestion] = useState(editData?.question || "");

  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(
    editData?.subjectId?._id || ""
  );

  const [remark, setRemark] = useState(editData?.remark || "");
  const [studentPaymentStatus, setStudentPayStatus] = useState(
    editData?.studentPaymentStatus || ""
  );
  const [paymentMethod, setPaymentMethod] = useState(
    editData?.paymentMethod || ""
  );
  const [studentPaymentId, setStudentPaymentId] = useState(
    editData?.paymentId || ""
  );

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        // const response = await axiosInstance.get(`admin/subject/getAllSubject`);
        const response = await axiosInstance.get(`admin/subSubject/getAllSubSubject`);
        if (response.data.isSuccess) {
          setSubjects(response.data.data);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again!!");
      }
    };

    fetchSubjects();
  }, []);
  const handleSubmitQuestion = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    if (editData?.question) {
      formData.append("question", question);
    }
    if (formRef.current?.assignment_file_question?.files) {
      for (
        let i = 0;
        i < formRef.current.assignment_file_question.files.length;
        i++
      ) {
        formData.append(
          "questionPDF",
          formRef.current.assignment_file_question.files[i]
        );
      }
    }
    for (
      let i = 0;
      i < formRef.current.assignment_file_reference.files.length;
      i++
    ) {
      formData.append(
        "referencePDF",
        formRef.current.assignment_file_reference.files[i]
      );
    }


    if (editData?.selectedSubject) {
      formData.append("subjectId", selectedSubject);
    }
    if (editData?.remark) {
      formData.append("remark", remark);
    }
    if (editData?.studentPaymentStatus) {
      formData.append("studentPaymentStatus", studentPaymentStatus);
    }
    if (editData?.paymentMethod) {
      formData.append("paymentMethod", paymentMethod);
    }
    formData.append("paymentId", studentPaymentId);
    if (editData?.questionStatus) {
      formData.append("questionStatus", editData.questionStatus);
    }
    formData.append("discountPrice", editData?.discountPrice?.toFixed(2));
    let  estimatedPriceValue = editData?.estimatedPrice?.toFixed(2);
    formData.append("estimatedPrice", estimatedPriceValue);

    try {
      setIsLoading(true);
      const response = await axiosInstance.put(
        `admin/assignmentHelp/updateQuestion/${editData._id}`,
        formData
      );

      if (response.data.isSuccess) {
        toast.success(response.data.message);
        resetForm();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    } finally {
      setIsLoading(false);
    }
  };

  const initialQuestionFiles = editData
    ? editData.questionPDF.map((file) => file.split("/").pop())
    : [];
  const initialReferenceFiles = editData
    ? editData.referencePDF.map((file) => file.split("/").pop())
    : [];
  const baseURL = process.env.REACT_APP_FILE_BASE_URL;

  const [selectedQuestionFiles, setSelectedQuestionFiles] =
    useState(initialQuestionFiles);
  const [selectedReferenceFiles, setSelectedReferenceFiles] = useState(
    initialReferenceFiles
  );

  const handleQuestionFileChange = (event) => {
    const files = event.target.files;
    const fileNames = Array.from(files).map((file) => file.name);
    setSelectedQuestionFiles([...selectedQuestionFiles, ...fileNames]);
  };

  const handleReferenceFileChange = (event) => {
    const files = event.target.files;
    const fileNames = Array.from(files).map((file) => file.name);
    setSelectedReferenceFiles([...selectedReferenceFiles, ...fileNames]);
  };

  const handleRemoveQuestionFile = async (index) => {
    const fileToRemove = editData?.questionPDF[index];
    const newFiles = selectedQuestionFiles.filter((_, i) => i !== index);
    newFiles.splice(index, 1);
    setSelectedQuestionFiles(newFiles);
    const requestData = {
      paymentSection: editData?.paymentSection,
      fieldName: "questionPDF",
      questionId: editData?._id,
      fileName: fileToRemove,
    };

    try {
      const response = await axiosInstance.post(
        "admin/deleteFile",
        requestData
      );
      if (response.data.isSuccess) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    }
  };

  const handleRemoveReferenceFile = async (index) => {
    const fileToRemove = editData?.referencePDF[index];
    const newFiles = selectedReferenceFiles.filter((_, i) => i !== index);
    newFiles.splice(index, 1);
    setSelectedReferenceFiles(newFiles);
    const requestData = {
      paymentSection: editData?.paymentSection,
      fieldName: "referencePDF",
      questionId: editData?._id,
      fileName: fileToRemove,
    };

    try {
      const response = await axiosInstance.post(
        "admin/deleteFile",
        requestData
      );
      if (response.data.isSuccess) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    }
  };

  useEffect(() => {
    calculateTotalPrice();
  }, [estimatedPrice, discountPrice, promoPrice]);

  const handleEstimatedPriceChange = (value) => {
    setEditData((prevEditData) => ({
      ...prevEditData,
      estimatedPrice: parseFloat(value),
    }));
    setEstimatedPrice(parseFloat(value) || 0);
    calculateTotalPrice();
  };

  const handleDiscountPriceChange = (value) => {
    setEditData((prevEditData) => ({
      ...prevEditData,
      discountPrice: parseFloat(value),
    }));
    setDiscountPrice(parseFloat(value) || 0);
    calculateTotalPrice();
  };

  const calculateTotalPrice = () => {
    const total = (estimatedPrice - discountPrice - promoPrice).toFixed(2);
    setTotalPrice(total);
  };

  const resetForm = () => {
    setQuestion("");
    setSelectedSubject("");
  };

  const handleRadioClick = (status) => {
    setEditData((prevEditData) => ({
      ...prevEditData,
      questionStatus: status,
    }));
  };


  const formatTime = (time) => {
    return time < 10 ? "0" + time : time;
  };

  return (
    <>
      <div className={`${Styles.second_container}`}>
        <div className="d-flex justify-content-between">
          <div className={`${Styles.order_text}`}>
            <p className={`${Styles.order_id}`}>
              Order ID: {editData?.displayId}
            </p>
            <p className={`${Styles.assignment_help_text}`}>
              Assignment Help - {editData?.subCategoryId?.name}
            </p>
          </div>
        </div>
        <div className={`bg-white ${Styles.assignment_content}`}>
          <div>
            <div className="d-flex justify-content-between ">
              <div className="d-flex ps-5 pt-5 pb-1 pe-5">
                <p className={`${Styles.time_stamp_heading}`}>Time Stamp</p>
                <p className={`ps-3 ${Styles.date_and_time}`}>
                  {dateFormat(editData?.updatedAt)}
                </p>
              </div>
            <div className="p-4">
  {editData &&
    editData?.studentPaymentStatus !== "Refund" &&
    editData?.questionStatus !== "Solved" &&
    (editData.remainingTime?.hours > 0 ||
      editData.remainingTime?.minutes > 0 ||
      editData.remainingTime?.seconds > 0) && (
      <div className="row text-center g-3 justify-content-center">
        
        <div className="col-4 col-md-3">
          <div className={Styles.timeCard}>
            <h2>{formatTime(editData?.remainingTime?.hours)}</h2>
            <span>HOURS</span>
          </div>
        </div>

        <div className="col-4 col-md-3">
          <div className={Styles.timeCard}>
            <h2>{formatTime(editData?.remainingTime?.minutes)}</h2>
            <span>MINUTES</span>
          </div>
        </div>

        <div className="col-4 col-md-3">
          <div className={Styles.timeCard}>
            <h2>{formatTime(editData?.remainingTime?.seconds)}</h2>
            <span>SECONDS</span>
          </div>
        </div>

      </div>
    )}

  {editData &&
    (editData.questionStatus === "Solved" ||
      (editData.remainingTime?.hours <= 0 &&
        editData.remainingTime?.minutes <= 0 &&
        editData.remainingTime?.seconds <= 0)) && (
      <div className={Styles.deadlineBox}>
        Deadline Over
      </div>
    )}
</div>
            </div>
            <hr />
            <div className="d-flex justify-content-between ">
              <div className="ps-5 pt-2">
                <span className={`${Styles.student_corner_text}`}>
                  Student Corner
                </span>
              </div>
            </div>
            <form
              ref={formRef}
              className="pt-3"
              onSubmit={handleSubmitQuestion}
            >
              <div className="ps-5 pe-5">
                <div className="form-group row mb-4">
                  <Label
                    for="inputPassword"
                    className="col-sm-3 col-form-label"
                  >
                    Email ID<b className="ms-2">:</b>
                  </Label>
                  <div className="col-sm-6">
                    <Input
                      type="text"
                      className="form-control"
                      id="emailid"
                      placeholder=""
                      defaultValue={editData?.studentId?.email}
                      disabled
                    />
                  </div>
                </div>
                <div className="form-group row mb-4">
                  <Label
                    for="inputPassword"
                    className="col-sm-3 col-form-label"
                  >
                    Question<b className="ms-2">:</b>
                  </Label>
                  <div className="col-sm-9">
                    <CommonEditor
                      value={question}
                      placeholder="Enter content ..."
                      onChange={setQuestion}
                      defaultValue={editData?.question}
                      readOnly={
                        editData?.studentPaymentStatus === "Completed" ||
                        editData?.studentPaymentStatus === "Refund"
                      }
                      className={`${Styles.h_200}`}
                    />
                  </div>
                </div>
                <div className="form-group row mb-4 mt-5 pt-3">
                  <Label className="col-sm-3 col-form-label">
                    Assignment File<b className="ms-2">:</b>
                  </Label>
                  <div
                    className="col-sm-9"
                    style={{
                      backgroundColor: "#F5F5F5",
                      height: "auto",
                      padding: "0px",
                    }}
                  >
                    <Input
                      type="file"
                      name="assignment_file_question"
                      disabled={
                        editData?.studentPaymentStatus === "Completed" ||
                        editData?.studentPaymentStatus === "Refund"
                      }
                      multiple
                      onChange={handleQuestionFileChange}
                    />
                    <div className="d-flex align-items-center mt-4">
                      {selectedQuestionFiles?.length > 0 && (
                        <ol>
                          {selectedQuestionFiles.map((file, index) => (
                            <li className="mb-2 answer-pdf" key={index}>
                              <Link
                                className="text-decoration-none"
                                to={`${baseURL}${editData?.questionPDF[index]}`}
                                target="_blank"
                              >
                                {file}
                              </Link>
                              <button
                                className="mx-2 answer-pdf-box"
                                onClick={() => handleRemoveQuestionFile(index)}
                                disabled={
                                  editData?.studentPaymentStatus ===
                                  "Completed" ||
                                  editData?.studentPaymentStatus === "Refund"
                                }
                              >
                                X
                              </button>
                            </li>
                          ))}
                        </ol>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form-group row mb-4 mt-5 pt-3">
                  <Label
                    for="inputPassword"
                    className="col-sm-3 col-form-label"
                  >
                    Reference File<b className="ms-2">:</b>{" "}
                  </Label>
                  <div
                    className="col-sm-9"
                    style={{
                      backgroundColor: "#F5F5F5",
                      height: "auto",
                      padding: "0px",
                    }}
                  >
                    <Input
                      type="file"
                      name="assignment_file_reference"
                      disabled={
                        editData?.studentPaymentStatus === "Completed" ||
                        editData?.studentPaymentStatus === "Refund"
                      }
                      multiple
                      onChange={handleReferenceFileChange}
                    />
                    <div className="d-flex align-items-center mt-4">
                      {selectedReferenceFiles?.length > 0 && (
                        <ol>
                          {selectedReferenceFiles.map((file, index) => (
                            <li className="mb-2 answer-pdf" key={index}>
                              <Link
                                className="text-decoration-none"
                                to={`${baseURL}${editData?.referencePDF[index]}`}
                                target="_blank"
                              >
                                {file}
                              </Link>
                              <button
                                className="mx-2 answer-pdf-box"
                                onClick={() => handleRemoveReferenceFile(index)}
                                disabled={
                                  editData?.studentPaymentStatus ===
                                  "Completed" ||
                                  editData?.studentPaymentStatus === "Refund"
                                }
                              >
                                X
                              </button>
                            </li>
                          ))}
                        </ol>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-4 mt-5 pt-3">
                  <Label
                    for="inputPassword"
                    className="col-sm-3 col-form-label"
                  >
                    Subject<b className="ms-2">:</b>
                  </Label>
                  <div className="col-sm-6">
                    <Input
                      id="subjectId"
                      name="subjectId"
                      type="select"
                      onChange={(e) => setSelectedSubject(e.target.value)}
                      value={selectedSubject}
                      disabled
                    >
                      <option value="">
                        {editData
                          ? editData?.subjectId
                            ? editData?.subjectId?.questionSubject
                            : "Please select subject"
                          : "Please select subject"}
                      </option>
                      {subjects?.map((subject) => (
                        <option key={subject._id} value={subject._id}>
                          {subject?.subSubjectName}
                        </option>
                      ))}
                    </Input>
                  </div>
                </div>
                <div className="form-group row mb-4">
                  <Label
                    for="inputPassword"
                    className="col-sm-3 col-form-label"
                  >
                    Remark<b className="ms-2">:</b>
                  </Label>
                  <div className="col-sm-6">
                    <textarea
                      type="text"
                      className="form-control"
                      id="remark"
                      placeholder=""
                      onChange={(e) => setRemark(e.target.value)}
                      defaultValue={editData?.remark}
                      disabled={
                        editData?.studentPaymentStatus === "Completed" ||
                        editData?.studentPaymentStatus === "Refund"
                      }
                    />
                  </div>
                </div>
                <div className="form-group row mb-4">
                  <Label
                    for="inputPassword"
                    className="col-sm-3 col-form-label"
                  >
                    Estimated Price<b className="ms-2">:</b>
                  </Label>
                  <div className="col-sm-6 d-flex align-items-center">
                    <span className={`${Styles.plandoll}`}>$</span>
                    {editData?.subCategoryId?._id ===
                      "6586dfe7d2f7eeadeea4fafa" ||
                      editData?.subCategoryId?._id ===
                      "6586d9a9dafb1f4a8f461274" ? (
                      <Input
                        type="text"
                        className="form-control"
                        id="inputPassword"
                        name="estimatedPrice"
                        placeholder=""
                        defaultValue={editData?.estimatedPrice?.toFixed(2)}
                        onChange={(e) =>
                          handleEstimatedPriceChange(e.target.value)
                        }
                        disabled={
                          editData?.studentPaymentStatus === "Paid" ||
                          editData?.studentPaymentStatus === "Completed" ||
                          editData?.studentPaymentStatus === "Refund" ||
                          (editData?.subCategoryId?._id !==
                            "6586d9a9dafb1f4a8f461274" &&
                            editData?.subCategoryId?._id !==
                            "6586dfe7d2f7eeadeea4fafa")
                        }
                      />
                    ) : (
                      // <span className={`${Styles.plandoll}`}>$</span>
                      <Input
                        type="text"
                        className="form-control"
                        id="inputPassword"
                        name="estimatedPrice"
                        placeholder=""
                        value={estimatedPriceData?.estimatedPrice?.toFixed(2)}
                        onChange={(e) =>
                          handleEstimatedPriceChange(e.target.value)
                        }
                        disabled={
                          editData?.studentPaymentStatus === "Paid" ||
                          editData?.studentPaymentStatus === "Completed" ||
                          editData?.studentPaymentStatus === "Refund" ||
                          (editData?.subCategoryId?._id !==
                            "6586d9a9dafb1f4a8f461274" &&
                            editData?.subCategoryId?._id !==
                            "6586dfe7d2f7eeadeea4fafa")
                        }
                      />
                    )}
                  </div>
                </div>

                <div className="form-group row mb-4">
                  <Label
                    for="inputPassword"
                    className="col-sm-3 col-form-label"
                  >
                    Discounted Price<b className="ms-2">:</b>
                  </Label>
                  <div className="col-sm-6 d-flex align-items-center">
                    <span className={`${Styles.plandoll}`}>$</span>
                    <Input
                      type="text"
                      className="form-control"
                      id="discountPrice"
                      placeholder=""
                      defaultValue={editData?.discountPrice?.toFixed(2)}
                      onChange={(e) =>
                        handleDiscountPriceChange(e.target.value)
                      }
                      disabled={
                        editData?.studentPaymentStatus === "Paid" ||
                        editData?.studentPaymentStatus === "Completed" ||
                        editData?.studentPaymentStatus === "Refund"
                      }
                    />
                  </div>
                </div>
                <div className="form-group row mb-4">
                  <Label
                    for="inputPassword"
                    className="col-sm-3 col-form-label"
                  >
                    Promocode Price<b className="ms-2">:</b>
                  </Label>
                  <div className="col-sm-6 d-flex align-items-center">
                    <span className={`${Styles.plandoll}`}>$</span>
                    <Input
                      type="text"
                      className="form-control"
                      id="inputPassword"
                      placeholder=""
                      defaultValue={editData?.promoPrice?.toFixed(2)}
                      disabled
                    />
                  </div>
                </div>
                <div className="form-group row mb-4">
                  <Label
                    for="inputPassword"
                    className="col-sm-3 col-form-label"
                  >
                    Promocode <b className="ms-2">:</b>
                  </Label>
                  <div className="col-sm-6">
                    <Input
                      type="text"
                      className="form-control"
                      id="inputPassword"
                      placeholder=""
                      defaultValue={editData?.promoCode}
                      disabled
                    />
                  </div>
                </div>
                <div className="form-group row mb-4">
                  <Label
                    for="inputPassword"
                    className="col-sm-3 col-form-label"
                  >
                    Total Price<b className="ms-2">:</b>
                  </Label>
                  <div className="col-sm-6 d-flex align-items-center">
                    <span className={`${Styles.plandoll}`}>$</span>
                    <Input
                      type="text"
                      className="form-control"
                      id="inputPassword"
                      placeholder=""
                      value={totalPrice}
                      disabled
                    />
                  </div>
                </div>
                <div className="form-group row mb-4">
                  <Label
                    for="inputPassword"
                    className="col-sm-3 col-form-label"
                  >
                    Payment Status<b className="ms-2">:</b>
                  </Label>
                  <div className="col-sm-6">
                    <Input
                      type="select"
                      className="form-control"
                      id="studentPaymentStatus"
                      placeholder=""
                      onChange={(e) => setStudentPayStatus(e.target.value)}
                      defaultValue={studentPaymentStatus}
                      disabled={
                        editData?.studentPaymentStatus === "Refund" ||
                        editData?.studentPaymentStatus === "Completed"
                      }
                    >
                      <option value="Paid">Paid</option>
                      <option value="Unpaid">Unpaid</option>
                      <option value="Refund">Refund</option>
                    </Input>
                  </div>
                </div>
                <div className="form-group row mb-4">
                  <Label
                    for="inputPassword"
                    className="col-sm-3 col-form-label"
                  >
                    Payment Method<b className="ms-2">:</b>
                  </Label>
                  <div className="col-sm-6">
                    <Input
                      type="select"
                      className="form-control"
                      id="paymentMethod"
                      placeholder=""
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      defaultValue={paymentMethod}
                      disabled={
                        editData?.studentPaymentStatus === "Refund" ||
                        editData?.studentPaymentStatus === "Paid" ||
                        editData?.studentPaymentStatus === "Completed"
                      }
                    >
                      <option value="Stripe">Stripe</option>
                      <option value="Razorpay">Razorpay</option>
                      <option value="Other">Other</option>
                    </Input>
                  </div>
                </div>
                <div className="form-group row mb-4">
                  <label
                    htmlFor="paymentId"
                    className="col-sm-3 col-form-label"
                  >
                    Payment Id <b className="ms-2">:</b>
                  </label>
                  <div className="col-sm-6">
                    <input
                      type="text"
                      className="form-control"
                      id="paymentId"
                      defaultValue={editData?.paymentId}
                      disabled={
                        editData?.studentPaymentStatus === "Refund" ||
                        editData?.studentPaymentStatus === "Unpaid" ||
                        editData?.studentPaymentStatus === "Completed"
                      }
                      onChange={(e) => setStudentPaymentId(e.target.value)}
                    />
                  </div>
                </div>
                {editData && editData?.studentPaymentStatus === "Paid" && (
                  <div className="form-group row mb-4">
                    <Label
                      for="inputPassword"
                      className="col-sm-3 col-form-label"
                    >
                      Answering Status<b className="ms-2">:</b>
                    </Label>
                    <div className="col-sm-9">
                      <div className="radio-btn mt-2">
                        <Row>
                          <Col md="3">
                            <FormGroup>
                              <Input
                                name="questionStatus"
                                type="radio"
                                onClick={() => handleRadioClick("Working")}
                                checked={
                                  editData &&
                                  editData.questionStatus === "Working"
                                }
                                disabled={
                                  editData?.studentPaymentStatus === "Refund" ||
                                  editData?.studentPaymentStatus === "Completed"
                                }
                              />
                              <Label className="mx-2">Working</Label>
                            </FormGroup>
                          </Col>
                          <Col md="3">
                            <FormGroup>
                              <Input
                                name="questionStatus"
                                type="radio"
                                onClick={() => handleRadioClick("Unsolved")}
                                checked={
                                  editData &&
                                  editData.questionStatus === "Unsolved"
                                }
                                disabled={
                                  editData?.studentPaymentStatus === "Refund" ||
                                  editData?.studentPaymentStatus === "Completed"
                                }
                              />
                              <Label className="mx-2">Not Working</Label>
                            </FormGroup>
                          </Col>
                          <Col md="3">
                            <FormGroup>
                              <Input
                                name="questionStatus"
                                type="radio"
                                onClick={() => handleRadioClick("Solved")}
                                checked={
                                  editData &&
                                  editData.questionStatus === "Solved"
                                }
                                disabled={
                                  editData?.studentPaymentStatus === "Refund" ||
                                  editData?.studentPaymentStatus === "Completed"
                                }
                              />
                              <Label className="mx-2">Solved</Label>
                            </FormGroup>
                          </Col>
                          <Col md="3">
                            <FormGroup>
                              <Input
                                name="questionStatus"
                                type="radio"
                                onClick={() => handleRadioClick("Close")}
                                checked={
                                  editData &&
                                  editData.questionStatus === "Close"
                                }
                                disabled={
                                  editData?.studentPaymentStatus === "Refund" ||
                                  editData?.studentPaymentStatus === "Completed"
                                }
                              />
                              <Label className="mx-2">Close</Label>
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div
                className={`d-flex justify-content-around ${Styles.quesion_color} p-3 mt-4`}
              >
                <div className="d-flex">
                  <div className={`${Styles.submit_button} me-4`}>
                    <Button
                      type="submit"
                      disabled={
                        editData?.studentPaymentStatus === "Refund" ||
                        editData?.studentPaymentStatus === "Completed"
                      }
                    >
                      {isLoading ? "Submitting..." : "Submit"}
                    </Button>
                  </div>
                  <div className={`${Styles.cancel_button}`}>
                    <Button
                      type="button"
                      className={`${Styles.cancel_button}`}
                      disabled={
                        editData?.studentPaymentStatus === "Refund" ||
                        editData?.studentPaymentStatus === "Completed"
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </form>
            <PaymentUpdates />
            <ForStudent />
          </div>
        </div>
      </div>
    </>
  );
};

export default Form;
